import { getEnvironment } from '@upright/common/environment';
import { useEffect, useState } from 'react';
import { getUiUrl } from '../../../../common/utils';

export function useLoadMaintenanceMode() {
  const env = getEnvironment();

  const [text, setText] = useState<string | undefined>();

  // Custom ugly fetch call due to fact that maintenance mode file is text file
  // TODO: make it a JSON file and use regular api functions
  useEffect(() => {
    const fetchTextFile = async () => {
      if (env === 'development') {
        setText(undefined);
      } else {
        try {
          const response = await fetch(`${getUiUrl()}/maintenance.txt`);
          const fileContent = await response.text();
          // A bit of a hack to see if the file is index.html, which is served if there's no maintenance.txt
          if (fileContent.substring(0, 1) !== '<') {
            setText(fileContent);
          }
        } catch (err) {
          return;
        }
      }
    };
    fetchTextFile();
  }, []);

  return text;
}
